module.exports = __webpack_public_path__ + "img/今日汇率.84b749a0.png";